class GivenNameService {
    renderFirstNames(firstNames: string, givenNameCode: string): string {
        return firstNames;
    }
}
export const GIVEN_NAME_SERVICE = new GivenNameService();